import { Controller } from "@hotwired/stimulus"

// application-settings--edit
//
// Handles the radio-driven label toggle for token lifetime type and
// Firebase project ID field visibility. AJAX form submission is delegated
// to the shared ajax-form controller.
export default class extends Controller {
  static targets = [
    "tokenLifetimeLabel",
    "firebaseAuthEnabled",
    "firebaseProjectIdWrap",
    "firebaseProjectId",
    "firebaseProjectIdWarning",
  ]

  connect() {
    this.syncFirebaseProjectIdWrap()
  }

  updateLifetimeLabel(event) {
    if (!this.hasTokenLifetimeLabelTarget) return

    const prefix = event.target.value === "true" ? "Inactivity" : "Absolute"
    this.tokenLifetimeLabelTarget.textContent = `${prefix} lifetime (1 - 31536000)`
  }

  toggleFirebaseProjectId() {
    this.syncFirebaseProjectIdWrap()
  }

  hideFirebaseProjectIdWarning() {
    if (!this.hasFirebaseProjectIdTarget || !this.hasFirebaseProjectIdWarningTarget) return

    if (this.firebaseProjectIdTarget.value.trim()) {
      this.firebaseProjectIdWarningTarget.style.display = "none"
    }
  }

  syncFirebaseProjectIdWrap() {
    if (!this.hasFirebaseProjectIdWrapTarget || !this.hasFirebaseAuthEnabledTarget) return

    this.firebaseProjectIdWrapTarget.hidden = !this.firebaseAuthEnabledTarget.checked
  }
}
